import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

export function DialogRoda({
    isVisibleRoda, setIsVisibleRoda,
    isVisibleRodaCE, setIsVisibleRodaCE,
    listaRodas, roda, setRoda,
    salvarRoda, deletarRoda,
}) {
    const abrirNovo = () => {
        setRoda({ id: null, nr_serie: '', validade: null, passadas_programadas: null });
        setIsVisibleRodaCE(true);
    };

    const abrirEdicao = (rowData) => {
        setRoda({ ...rowData });
        setIsVisibleRodaCE(true);
    };

    return (
        <>
            {/* Listagem */}
            <Dialog
                header="Rodas Cadastradas"
                onHide={() => setIsVisibleRoda(false)}
                style={{ minWidth: '50vw' }}
                visible={isVisibleRoda}
            >
                <div className="p-fluid">
                    <div className="p-d-flex p-flex-row p-jc-end p-ai-center p-m-1">
                        <Button className="p-m-1" icon="pi pi-plus" onClick={abrirNovo} title="Cadastrar uma roda" />
                    </div>
                    <DataTable
                        value={listaRodas}
                        className="p-m-1"
                        emptyMessage="Nenhum registro lançado até o momento"
                        responsiveLayout="scroll"
                        size="small"
                    >
                        <Column header="Nº Série" field="nr_serie" sortable style={{ width: "40%" }} />
                        <Column header="Validade" field="validade" style={{ width: "25%" }}
                            body={(row) => `${row.validade} anos`} />
                        <Column header="Passadas Programadas" field="passadas_programadas" style={{ width: "25%" }} />
                        <Column
                            header="Ação"
                            style={{ textAlign: 'center' }}
                            headerStyle={{ display: 'flex', justifyContent: 'center' }}
                            body={(row) => (
                                <div style={{ display: 'flex', gap: 5, justifyContent: 'center' }}>
                                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-text"
                                        onClick={() => abrirEdicao(row)} />
                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deletarRoda(row)} />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </Dialog>

            {/* Cadastro / Edição */}
            <Dialog
                visible={isVisibleRodaCE}
                style={{ width: '450px' }}
                header={roda.id ? "Editar Roda" : "Cadastrar Nova Roda"}
                modal
                className="p-fluid"
                onHide={() => setIsVisibleRodaCE(false)}
                footer={
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text"
                            onClick={() => setIsVisibleRodaCE(false)} />
                        <Button label="Salvar" icon="pi pi-check" onClick={salvarRoda} autoFocus />
                    </div>
                }
            >
                <div className="p-field p-mt-3">
                    <label htmlFor="roda_nr_serie">Nº de Série</label>
                    <InputText id="roda_nr_serie" maxLength={32} required value={roda.nr_serie}
                        onChange={(e) => setRoda({ ...roda, nr_serie: e.target.value })} />
                </div>
                <div className="p-field p-mt-3">
                    <label htmlFor="roda_validade">Validade (em Anos)</label>
                    <InputNumber id="roda_validade" min={1} required value={roda.validade}
                        onValueChange={(e) => setRoda({ ...roda, validade: e.value })} />
                </div>
                <div className="p-field p-mt-3">
                    <label htmlFor="roda_passadas_programadas">Passadas Programadas</label>
                    <InputNumber id="roda_passadas_programadas" min={1} required value={roda.passadas_programadas}
                        onValueChange={(e) => setRoda({ ...roda, passadas_programadas: e.value })} />
                </div>
            </Dialog>
        </>
    );
}